import StripeAddCardErrorModal from './StripeAddCardErrorModal';

export default StripeAddCardErrorModal;
